import styled from 'styled-components'

export const FlexAlignCenter = styled.div`
    display: flex;
    align-items: center;
    height: 100%;
`

export const FlexJustSpaceBetween = styled.div`
    display: flex;
    justify-content: space-between;
`
